import Aram_Qr from "../Assets/Images/Aram_Qr.jpg";
import Balen_Qr from "../Assets/Images/Balen_Qr.jpg";
import Asia_Qr from "../Assets/Images/Asia_Qr.jpg";
import { useParams, useSearchParams } from "react-router-dom";
function Profiles() {
  const { id } = useParams();
  const profiles = [
    {
      name: "Aram Omar",
      position: "CEO",
      phone: "0750 4923439",
      email: "ceo@chinastars-iq.com",
      address: "Shaqlawa Road, Erbil",
      website: "www.chinastars-iq.com",
      code: "76CF9B369FDA4D2DB4FB6F2C92A72B79",
      qrCode: Aram_Qr,
    },
    {
      name: "Asya O. Anwer",
      position: "Supply Chain Manager",
      phone: "0785 2112112",
      email: "supplychain@chinastars-iq.com",
      address: "Shaqlawa Road, Erbil",
      website: "www.chinastars-iq.com",
      code: "4231D184354E4323A7958B311C0177A1",

      qrCode: Asia_Qr,
    },
    {
      name: "Balen A. Salih",
      position: "Import Export Manager",
      phone: "0775 2112112",
      email: "Import_export@chinastars-iq.com",
      address: "Shaqlawa Road, Erbil",
      website: "www.chinastars-iq.com",
      code: "57C0939EB3BE4165A435E111006D6D3D",
      qrCode: Balen_Qr,
    },
  ];
  const filteredProfile = profiles.filter((el) => el.code === id);
  return (
    <div>
      <div className="bg-primary py-4">
        <div className="container d-lg-flex justify-content-between py-2 py-lg-3">
          <div className="order-lg-1 pe-lg-4 text-center text-lg-start">
            <h1 className=" mb-0 text-light">{window.t("Profiles")}</h1>
          </div>
        </div>
      </div>
      <section className="container-fluid pt-grid-gutter">
        <div className="row">
          {filteredProfile.map((pro, index) => {
            const whatsappNumber = pro.phone.replace(/\D/g, "");
            return (
              <div className="col-12 col-md-6 mx-auto m-5">
                <div className="card-body text-center  bg-light rounded">
                  <p className="fs-sm-md-lg-1 text-primary ">{pro.name}</p>
                  <p className="fs-sm-md-lg-2 text-secondary">{pro.position}</p>
                  <div className="fs-sm-md-lg-2 text-muted d-flex align-items-center justify-content-between px-2">
                    <div className="d-flex flex-column gap-2 align-items-start justify-content-start flex-1">
                      <a
                        target="_blank"
                        href={`https://wa.me/${whatsappNumber}`}
                        className="d-flex align-items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>
                        {pro.phone}
                      </a>
                      <a
                        target="_blank"
                        href={`mailto:${pro.email}`}
                        className="d-flex align-items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-envelope-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                        </svg>
                        {pro.email}
                      </a>
                      <a
                        target="_blank"
                        href={pro.website}
                        className="d-flex align-items-center gap-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-browser-edge"
                          viewBox="0 0 16 16"
                        >
                          <path d="M9.482 9.341c-.069.062-.17.153-.17.309 0 .162.107.325.3.456.877.613 2.521.54 2.592.538h.002c.667 0 1.32-.18 1.894-.519A3.84 3.84 0 0 0 16 6.819c.018-1.316-.44-2.218-.666-2.664l-.04-.08C13.963 1.487 11.106 0 8 0A8 8 0 0 0 .473 5.29C1.488 4.048 3.183 3.262 5 3.262c2.83 0 5.01 1.885 5.01 4.797h-.004v.002c0 .338-.168.832-.487 1.244l.006-.006z" />
                          <path d="M.01 7.753a8.14 8.14 0 0 0 .753 3.641 8 8 0 0 0 6.495 4.564 5 5 0 0 1-.785-.377h-.01l-.12-.075a5.5 5.5 0 0 1-1.56-1.463A5.543 5.543 0 0 1 6.81 5.8l.01-.004.025-.012c.208-.098.62-.292 1.167-.285q.194.001.384.033a4 4 0 0 0-.993-.698l-.01-.005C6.348 4.282 5.199 4.263 5 4.263c-2.44 0-4.824 1.634-4.99 3.49m10.263 7.912q.133-.04.265-.084-.153.047-.307.086z" />
                          <path d="M10.228 15.667a5 5 0 0 0 .303-.086l.082-.025a8.02 8.02 0 0 0 4.162-3.3.25.25 0 0 0-.331-.35q-.322.168-.663.294a6.4 6.4 0 0 1-2.243.4c-2.957 0-5.532-2.031-5.532-4.644q.003-.203.046-.399a4.54 4.54 0 0 0-.46 5.898l.003.005c.315.441.707.821 1.158 1.121h.003l.144.09c.877.55 1.721 1.078 3.328.996" />
                        </svg>
                        {pro.website}
                      </a>

                      <a
                        target="_blank"
                        href="https://maps.app.goo.gl/ZRV8baMgRS12TutP6?g_st=ipc"
                        className="d-flex align-items-center gap-2 "
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-geo-alt-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                        </svg>
                        {pro.address}
                      </a>
                    </div>
                    {pro.qrCode && (
                      <div className="qr-code-profile w-25">
                        <img
                          style={{
                            width: "175px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                          className=""
                          src={pro.qrCode}
                        />
                        <a
                          href={pro.qrCode}
                          download={pro.name + ".png"}
                          style={{ fontSize: "10px" }}
                          className="btn btn-primary btn-sm px-3 py-0 text-decoration-none "
                        >
                          {window.t("download")}
                        </a>
                      </div>
                    )}
                  </div>
                  <p className="fs-sm-md-lg-2 text-muted">{pro.link}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default Profiles;
